<template>
  <Modal
    v-if="!!ctx.mapElem.mapDeleteConfirmElem"
    title="削除確認"
    bottomCloseButtonLabel="削除"
    bottomCloseButtonClass="btn-danger"
    @close="ctx.doDeleteMapSelectedElem()"
    @dismiss="ctx.cancelDeleteMapSelectedElem()"
  >
    <template #body>
      {{ ctx.mapElem.mapDeleteConfirmElem?.confirmMessage }}
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { useMapSelectionStore } from 'src/composables/useMapSelection';

const ctx = useMapSelectionStore();
</script>
